import { reducer as app } from './app/slice';
import { reducer as auth } from './auth/slice';
import { reducer as campaigns } from './campaigns/slice';
import { reducer as contacts } from './contacts/slice';
import { reducer as emails } from './emails/slice';
import { reducer as emailTemplates } from './emailTemplates/slice';
import { reducer as groups } from './groups/slice';
import { reducer as pointage } from './pointage/slice';
import { reducer as roles } from './roles/slice';
import { reducer as sms } from './sms/slice';
import { reducer as sourceEmails } from './sourceEmails/slice';
import { reducer as sourcePhoneNumbers } from './sourcePhoneNumbers/slice';
import { reducer as tags } from './tags/slice';
import { reducer as users } from './users/slice';

const rootReducer = {
  app,
  auth,
  campaigns,
  contacts,
  emails,
  emailTemplates,
  groups,
  pointage,
  roles,
  sms,
  sourceEmails,
  sourcePhoneNumbers,
  tags,
  users,
};

export default rootReducer;
